import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { travelerAppConfigToken } from './shared/config/tokens';
import { MatButtonModule } from '@angular/material/button';
import { ApplicationInsightsService } from '@tbums.mono.web/tbums-lib';
import { TravelerAppConfig } from './shared/config/traveler-app-config.model';
import { TagService } from './shared/services/tag.service';

@Component({
  imports: [RouterModule, MatToolbarModule, MatButtonModule],
  selector: 'traveler-root',
  template: ` <router-outlet></router-outlet>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  appConfig = inject<TravelerAppConfig>(travelerAppConfigToken);
  tagService = inject(TagService);
  applicationInsightsService = inject(ApplicationInsightsService);

  constructor() {
    this.tagService.metaDataLanguagePicker();
    this.applicationInsightsService.initialization(this.appConfig.appInsightsInstrumentationKey);
  }
}
